module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("Hönsestrik – a love story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter41#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAVERICK CARDIGAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter42#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHOLE YOKE JUMPER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter43#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLIPOVER VEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter44#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHICKENWRAP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter45#C4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHOLE YOKE COWL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter46#C4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COSY TASSEL PONCHO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter47#C4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY FUNDAY HOT PANTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter48#C4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MISMATCHED MITTENS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter49#C4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLAY IT SAFE MITTENS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter410#C4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CANDY MITTENS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter411#C4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLOUCHY BEANIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter412#C4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCALLOPED-EDGE BEANIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When it doesn't turn out as expected")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Pattern_library",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pattern library")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Thank_yous",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank yous")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0